<template>
  <span class="tag-info" :title="title">?</span>
</template>

<script>
export default {
  props: ['title'],
}
</script>
